import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useQueryClient } from 'react-query';

import PageBreadcrumb from 'components/common/PageBreadcrumb';
import { comingBreadcrumbItems } from 'data/returning';
import ComingFilterReturning from './ComingFilter';
import ComingFilterReturningTable from './ComingFilterReturningTable';
import ButtonRefresh from 'components/base/ButtonRefresh';

const ComingOutReturning = () => {
  const { t } = useTranslation();
  const queryClient = useQueryClient();

  // const handleRefetch = () => {
  //   queryClient.refetchQueries('GET_RETUNR_IN_LIST');
  // };

  const [dateFrom, setDateFrom] = useState(null);
  const [dateTo, setDateTo] = useState(null);
  const [optionSenderId, setOptionSenderId] = useState(null);
  const [optionStatusId, setOptionStatusId] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);

  return (
    <div>
      <PageBreadcrumb items={comingBreadcrumbItems} />
      <div>
        <div className="mb-5 d-flex gap-2 align-items-center">
          <h2>{t('incoming')}</h2>
          <ButtonRefresh
            onRefresh={() => queryClient.refetchQueries('GET_RETUNR_IN_LIST')}
          />
        </div>

        <ComingFilterReturning
          dateFrom={dateFrom}
          dateTo={dateTo}
          setDateFrom={setDateFrom}
          setDateTo={setDateTo}
          setOptionSenderId={setOptionSenderId}
          setOptionStatusId={setOptionStatusId}
          optionSenderId={optionSenderId}
          optionStatusId={optionStatusId}
          setCurrentPage={setCurrentPage}
        />
        <ComingFilterReturningTable
          dateFrom={dateFrom}
          dateTo={dateTo}
          optionSenderId={optionSenderId}
          optionStatusId={optionStatusId}
          currentPage={currentPage}
          setCurrentPage={setCurrentPage}
        />
      </div>
    </div>
  );
};

export default ComingOutReturning;
